module.exports = __webpack_public_path__ + "static/media/fringe-elements.12e69fa1.jpg";